var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvaluate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1.66667H12.35C12 0.7 11.0833 0 10 0C8.91667 0 8 0.7 7.65 1.66667H2.5V18.3333H17.5V1.66667ZM10 1.66667C10.4583 1.66667 10.8333 2.04167 10.8333 2.5C10.8333 2.95833 10.4583 3.33333 10 3.33333C9.54167 3.33333 9.16667 2.95833 9.16667 2.5C9.16667 2.04167 9.54167 1.66667 10 1.66667ZM15.8333 16.6667H4.16667V3.33333H5.83333V5.83333H14.1667V3.33333H15.8333V16.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluate);
export default __webpack_public_path__ + "static/media/evaluate.874f79f152f59b250c96277e97bdc6cb.svg";
export { ForwardRef as ReactComponent };